import App from "@bloglovin/inspire-engine/App";
import { contextualAppName } from "%/dynamic-component-editor/classes/platform-standard-entities";
import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { readBoundContextName, resolveBoundEntityId } from "%/dynamic-component-editor/helpers/bound-context-entity-id";

const SEASON_ENTITY_TYPE = "Season";

const EMPTY_SEASON_ENTITY = Object.freeze({
  id: 0,
  name: "",
  description: "",
  image: "",
  seasonNumber: 0,
  numEpisodes: 0,
  storyId: 0,
  show: null,
});

export const BaseSeasonCardElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    useExampleData: { default: () => () => false },
    scopedProvidedContexts: { default: null },
  },
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    boundContextName() {
      return readBoundContextName(this);
    },
    seasonEntityId() {
      return resolveBoundEntityId(this, "season");
    },
    hasResolvedSeasonEntity() {
      const id = this.seasonEntityId;
      if (!id) {
        return false;
      }
      const entity = App.get(contextualAppName()).getEntity(SEASON_ENTITY_TYPE, { id });
      return Boolean(entity && entity.isHydrated);
    },
    hideUntilSeasonEntityResolved() {
      return !this.editMode && !this.isPreviewMode && !this.hasResolvedSeasonEntity;
    },
  },
  methods: {
    getRealEntity() {
      if (this.isPreviewMode) {
        return this.$options.exampleEntity ?? EMPTY_SEASON_ENTITY;
      }
      const id = this.seasonEntityId;
      if (!id) {
        return EMPTY_SEASON_ENTITY;
      }
      const entity = App.get(contextualAppName()).getEntity(SEASON_ENTITY_TYPE, { id });
      return entity || EMPTY_SEASON_ENTITY;
    },
  },
  exampleEntity: {
    id: 1,
    name: "Demo Season",
    description: "A demo season description.",
    image: "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/fashion-story-sample-image.webp",
    seasonNumber: 1,
    numEpisodes: 8,
    storyId: 0,
    show: { entityType: "Show", pk: { id: 1 } },
  },
};
